import angular from 'angular';

import WordSwitcherComponent from './word-switcher.cmpt';

export default angular
    .module('presentation.component.word-switcher', [])
    .component(WordSwitcherComponent.selector, WordSwitcherComponent);



// WEBPACK FOOTER //
// ./src/presentation/component/word-switcher/index.js